<script lang="ts">
	//UI
	import RevenueCalendar from "@hitit/hub/src/v7/components/revenue/RevenueCalendar.svelte";
	import OrderHistory from "../component/Revenue/OrderHistory.svelte";

	//Utils
	import { endOfMonth, startOfMonth } from "date-fns";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	//Types
	//Props
	export let date = new Date();
	export let storeId = "";

	//Constants
	//Variables
	$: range = {
		start: startOfMonth(date),
		end: endOfMonth(date),
	};
	//Functions
	//Do
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<RevenueCalendar storeId={storeId} bind:date />
	<OrderHistory storeId={storeId} range={range} />
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		gap: 30px;
	}

</style>
